import { exit } from "process"

import { preload } from "shared/shared.preload"
import { detectSSOTokensForBrodcast } from "web/utils/detectSSOTokensInURL"
import * as webElectron from "web/webElectron"

if (detectSSOTokensForBrodcast()) {
  exit(0)
}

preload(webElectron)
  .then(async () => {
    const { loadRoot } = await import("./loadRoot")
    loadRoot("web")
  })
  .catch((error) => {
    console.error("Error during preload initialization:", error)
  })
